import styled, { css } from 'styled-components';
import { timingDefault } from '../../constants';
import { getPastelColor } from '../../lib/utils/color';
import { focusOutline } from '../../utility-classes';
import { useLmfAnalyticsOnClick } from '../Analytics/LmfAnalyticsProvider';
const verticalWidth = '38px';
const horizontalWidths = {
    sm: '38px',
    md: '48px',
    lg: '104px',
};
const spacing = '8px';
const borderRadius = '4px';
export const Body = styled.button.attrs(o => {
    const onClickWithTracking = useLmfAnalyticsOnClick({
        element: 'variant-button',
        variations: ['default'],
        label: o['aria-label'],
        href: undefined,
        onClick: o.onClick,
    });
    return {
        'data-size-availability': o.soldOut ? 'unavailable' : 'available',
        'onClick': onClickWithTracking,
    };
}) `
  min-width: ${horizontalWidths.sm};

  ${o => o.minWidthStyle === 'md' &&
    css `
      min-width: ${horizontalWidths.md};
    `}

  ${o => o.minWidthStyle === 'lg' &&
    css `
      min-width: ${horizontalWidths.lg};
    `}

  background-color: ${o => {
    if (o.isSelected && o.soldOut)
        return o.theme.color.deprecated.stone;
    if (o.refreshedColors) {
        if (o.isSelected)
            return o.theme.color.fill.background;
        return o.theme.color.fill.background;
    }
    else {
        if (o.isSelected)
            return o.accentColor ?? o.theme.color.deprecated.obsidian;
        return 'white';
    }
}};
  border: 1px solid
    ${o => {
    if (o.refreshedColors) {
        return !o.isSelected
            ? o.theme.color.stroke.neutral.border.decoration.on.background
            : o.theme.color.stroke.neutral.border.interaction.primary.on.background;
    }
    else {
        return !o.isSelected
            ? o.theme.color.deprecated.stone
            : o.accentColor ?? o.theme.color.deprecated.obsidian;
    }
}};
  border-radius: ${borderRadius};
  color: ${o => {
    if (o.soldOut && !o.isSelected)
        return o.theme.color.deprecated.stoneDark;
    if (o.refreshedColors) {
        if (!o.soldOut && o.isSelected)
            return o.theme.color.text.primary.on.background;
        return o.theme.color.text.primary.on.background;
    }
    else {
        if (!o.soldOut && o.isSelected)
            return 'white';
        if (o.accentColor && o.isSelected)
            return 'white';
        return o.theme.color.deprecated.obsidian;
    }
}};
  cursor: pointer;
  font-size: 11px;
  font-weight: 700;
  min-height: ${verticalWidth};
  letter-spacing: 0.6px;
  margin-top: 0;
  margin-bottom: ${spacing};
  margin-inline-start: 0;
  margin-inline-end: ${spacing};
  padding: 0 8px;
  position: relative;
  text-align: center;
  text-transform: ${o => o.textTransform};
  transition-property: background-color, border-color, color;
  transition-duration: ${timingDefault};
  transition-timing-function: ease;
  overflow: hidden;

  &::after {
    background: ${o => o.soldOut
    ? `linear-gradient(
      to top left,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0) calc(50% - 0.75px),
      ${o.isSelected ? o.theme.color.deprecated.obsidian : o.theme.color.deprecated.stone} 50%,
      rgba(0, 0, 0, 0) calc(50% + 0.75px),
      rgba(0, 0, 0, 0) 100%
    )`
    : 'none'};
    border: 1px solid transparent;
    border-radius: ${borderRadius};
    content: '';
    display: block;
    min-height: ${verticalWidth};
    left: -1px;
    position: absolute;
    top: -1px;
    width: 100%;
  }

  &:hover,
  &:focus {
    background-color: ${o => {
    if (o.isSelected)
        return undefined;
    if (o.accentColor)
        return getPastelColor(o.accentColor, '2a');
    return o.theme.color.deprecated.stoneLighter;
}};
  }

  ${focusOutline};
`;
//# sourceMappingURL=styles.js.map